module.exports = __webpack_public_path__ + "static/img/company_news04.e194bed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutMe/company_news04.jpg
// module id = lpdn
// module chunks = 2